/**
 *  PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2024 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
/**
 * @file Header.jsx - A component for agentic header.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { shapes } from '@greenville/framework';
import { withStyles, Box, Typography, Tooltip } from '@material-ui/core';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import TenantsModel from '../../models/TenantsModel';
import HeaderStyles from './HeaderStyles';
import { BERLIN_STUDIO, SELECT_TENANT } from '../../constants/AgenticTextConstants';

const Header = ({ classes, currentGraphName, onTenantChange, tenantState, graphVersion, graphStatus }) => {
  const { tenantList, selectedTenant } = tenantState;
  return (
    <Box className={classes.headerContainer}>
      <Box className={classes.headerWrapper}>
        <Box className={classes.heading}>
          <Typography variant="h1" className={classes.graphHeading}>
            {currentGraphName === '' ? (
              BERLIN_STUDIO
            ) : (
              <>
                {BERLIN_STUDIO} (
                {currentGraphName && currentGraphName.length > 24 ? (
                  <Tooltip title={currentGraphName}>
                    <span className={classes.graphNameEllipsis}>{currentGraphName}</span>
                  </Tooltip>
                ) : (
                  <span className={classes.graphNameEllipsis}>{currentGraphName}</span>
                )}{' '}
                | {graphVersion} | {graphStatus} )
              </>
            )}
          </Typography>
        </Box>
        <FormControl classes={{ root: classes.formContainer }} size="small">
          <InputLabel className={classes.color} id="tenantLabelId">
            {SELECT_TENANT}
          </InputLabel>
          <Select
            labelId="tenantLabelId"
            label={SELECT_TENANT}
            name="tenantId"
            value={selectedTenant?.tenantId || ''}
            onChange={onTenantChange}
            className={classes.color}
            classes={{
              icon: classes.color
            }}
          >
            <MenuItem disabled value="">
              <em>{SELECT_TENANT}</em>
            </MenuItem>
            {tenantList &&
              tenantList.map((item) => (
                <MenuItem key={item.tenantId} value={item.tenantId}>
                  {item.title}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  currentGraphName: PropTypes.string.isRequired,
  onTenantChange: PropTypes.func.isRequired,
  graphVersion: PropTypes.number.isRequired,
  graphStatus: PropTypes.string.isRequired,
  tenantState: shapes.modelOf(TenantsModel).isRequired
};

export default inject('tenantState')(observer(withStyles(HeaderStyles)(Header)));
